import { useCallback } from 'react';

import { useLocale } from '@tanium/react-locale-context';

import { labelPercentFormatter } from '../formatters/labelPercentFormatter';
import { NumberCoercible } from '../utils/NumberCoercible';
import { NumberFormatterType } from '../utils/NumberFormatterType';

/**
 * Hook that returns a locale aware adjusted slice percent formatter for use in labels.
 */
export const useLocalizedLabelPercentFormatter = (): NumberFormatterType => {
  const locale = useLocale();
  return useCallback((value: NumberCoercible) => labelPercentFormatter(value, locale), [locale]);
};
